import {Routes} from "@angular/router";
import {LoginPage} from "./login/login.page";
import {SignupPage} from "./signup/signup.page";
import {OnboardingScreenPage} from "./onboarding-screen/onboarding-screen.page";
import {ForgotPage} from "./forgot/forgot.page";
import {ActivatePage} from "./activate/activate.page";
import {ChangePasswordPage} from "./change-password/change-password.page";

export const authenticationRoutes: Routes = [
    {
        path: 'login',
        component: LoginPage
    },
    {
        path: 'signup',
        component: SignupPage
    },
    {
        path: 'forgot',
        component: ForgotPage
    },
    {
        path: 'activate/:key',
        component: ActivatePage
    },
    {
        path: 'reset/:key',
        component: ChangePasswordPage
    }
];
